@use '../../scss/global' as *;
@use 'themes';

// ================================================================ //
// -- Local Variables

// ================================================================ //
// -- Component Styles

:host {
  display: block;

  .fluid-form {
    margin-bottom: 1em;
  
    // == Remove Bottom Margin
  
    &.inline {
      margin-bottom: 0;
    }
  
    // ==== Embedded Grid
  
    fluid-grid {
  
      // NB: Used to highlight the grid items to aid with debugging layout.
      // Should really be @internal, but may as well expose the option until
      // the layout configurator is complete.
      &.show-grid {
        fluid-grid-item {
          border: 1px dotted lightgrey;
          background-color: $liberty-gray-2;
  
          fluid-grid-item {
            background-color: darken($liberty-gray-2, 5%);
          }
        }
      }
  
      // NB: Used for "grid row" layout only (i.e. "GridRowLayout" functional
      // component) - removes negative top/bottom margin from each row's
      // "parent" Grid to offset the negative top/bottom margin of its nested
      // "child" Grid. Basically, this makes the layout's vertical spacing
      // (i.e. padding between rows) consistent with all other Form layouts.
      &.no-vertical-margin {
        margin-top: 0;
        margin-bottom: 0;
      }
    }
  
    // ==== Embedded Grid Item
  
    fluid-grid-item {
  
      // == Hidden Field
  
      &.hidden {
        display: none !important;
      }
  
      // == "Filler" Column ("Row" Layout)
  
      &.filler-column {
        padding: 0;
      }
  
      // == Vertical Alignment ("Row" Layout)
  
      &.align-items {
        display: flex;
  
        &-start { align-items: flex-start; }
        &-center { align-items: center; }
        &-end { align-items: flex-end; }
        &-stretch { align-items: stretch; }
        &-baseline { align-items: baseline; }
  
        & > fluid-form-element {
          flex: 1 1 auto;
        }
      }
  
      // NB: Used for row/column layout only - shouldn't be needed, as element
      // widths are controlled at a row level, so no need to pack two fields
      // into one column - just configure another column for that row!
      &.has-multiple-elements {
        display: flex; // Make Grid Item emulate Grid
        flex-wrap: wrap;
  
        fluid-grid-item {
          padding: 0; // Remove padding since parent Grid Item doesn't have negative margins
  
          & + fluid-grid-item {
            padding-left: 16px; // Emulate default spacing between consecutive Grid Items
          }
        }
      }
  
      // == Prevent Form Element Overflow
  
      & > fluid-form-element {
        max-width: 100%;
      }
    }
  }
}
